<template>
  <el-form
    label-position="top"
    :model="form"
    :rules="rules"
    ref="form"
    class="text-left"
  >
    <el-row :gutter="30">
      <el-col :span="24">
        <el-form-item
          label="ชื่อหัวข้อแบบประเมินการเรียนออนไลน์"
          prop="feedbackName"
        >
          <el-input v-model="form.feedbackName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="ประเภทแบบประเมินการเรียนออนไลน์"
          prop="type"
        >
          <el-radio v-model="form.type" :label="1" @change="form.required = false">คะแนน</el-radio>
          <el-radio v-model="form.type" :label="2" >ข้อความ</el-radio>
        </el-form-item>
          
      </el-col>

      <el-col v-if="form.type == 2" :span="24">
        <el-form-item
          label="ต้องการบังคับกรอกหรือไม่"
          prop="required"
        >
          <el-checkbox v-model="form.required">บังคับกรอก</el-checkbox>
        </el-form-item>
          
      </el-col>
    </el-row>

    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createFeedback"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มแบบประเมิน</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateFeedback"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    feedback: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      form: {
        feedbackName: "",
        type:1,
        required:false
      },
      rules: {
        feedbackName: [
          {
            required: true,
            message: "กรุณากรอกชื่อหัวข้อแบบประเมินการเรียนออนไลน์",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "กรุณาเลือกประเภทแบบประเมินการเรียนออนไลน์",
            trigger: "blur",
          },
        ],
      },
      feedbackId: "",
    };
  },
  watch: {
    feedBack() {
      this.setFeedback();
    },
  },
  mounted() {
    this.setFeedback();
  },
  methods: {
    setFeedback() {
      if (this.feedback != null) {
        this.form = {
          feedbackName: this.feedback.name,
          type: typeof this.feedback.type !== 'undefined'?this.feedback.type:1,
          required: typeof this.feedback.required !== 'undefined'?this.feedback.required:false,
        };

        this.feedbackId = this.feedback._id;
      }
    },
    createFeedback() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("createFeedback", this.form);
        }
      });
    },
    updateFeedback() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("updateFeedback", this.form, this.feedbackId);
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
